import React from 'react';
import { Eyebrow, SectionLead, SectionShell, SectionTitle } from '../SectionShell';
import { CtaButton } from '../CtaButton';
import { pains } from '../../data/content';
export function PainPoints() {
  return <SectionShell tone="white" data-id="element-229" data-mp="27nc8ug9r7dj1">
      <Eyebrow data-id="element-230" data-mp="27nlphd8ws8c2">¿Te suena familiar?</Eyebrow>
      <SectionTitle data-id="element-231" data-mp="22vu3zh4m0sss">¿Te suena familiar alguna de estas situaciones?</SectionTitle>
      <SectionLead data-id="element-232" data-mp="2hkhzxoidb4j9">
        Si respondiste “sí” a una sola… Ruta Enfermedad Renal™ fue creada exactamente para ti.
      </SectionLead>

      <div className="mt-8 grid grid-cols-1 gap-3.5 sm:grid-cols-2" data-id="element-233" data-mp="2cm6s1jbmv43o">
        {pains.map(pain => <article key={pain.title} className="rounded-2xl border border-navy-100 bg-cream-50 p-4 sm:p-5" data-id="element-234" data-mp="2qk50y976q8bs">
            <span className="text-2xl leading-none" aria-hidden="true" data-id="element-235" data-mp="2mhgpruv00pbn">
              {pain.emoji}
            </span>
            <h3 className="mt-2.5 font-display text-[17px] font-bold leading-snug text-navy-900 sm:text-lg" data-id="element-236" data-mp="s5jxy0sn9hg2">
              {pain.title}
            </h3>
            <p className="mt-2 text-[13.5px] leading-relaxed text-navy-700/80" data-id="element-237" data-mp="1n9egrzarz4b2">{pain.text}</p>
          </article>)}
      </div>

      <div className="mt-8 rounded-3xl bg-navy-800 px-5 py-7 text-center sm:px-8" data-id="element-238" data-mp="1s4jyelx59wtc">
        <p className="font-display text-[19px] font-bold leading-snug text-white sm:text-2xl" data-id="element-239" data-mp="1x3wmtb3nzby1">
          No necesitas memorizar cientos de páginas de KDIGO.
        </p>
        <p className="mt-3 text-[14.5px] leading-relaxed text-cream-100/80 sm:text-base" data-id="element-240" data-mp="26v10m7hlsqra">
          Necesitas una ruta que convierta la evidencia en decisiones clínicas. Eso es exactamente lo
          que hace <strong className="text-renal-400" data-id="element-241" data-mp="2fxseedxybym3">Ruta Enfermedad Renal™</strong>.
        </p>
      </div>

      <div className="mt-8" data-id="element-242" data-mp="2ku959fwjcr2v">
        <CtaButton label="Quiero eliminar esas dudas hoy" sub="Acceso inmediato por USD 15 • Garantía de 7 días" data-id="element-243" data-mp="2kthgop1cvtm3" />
      </div>
    </SectionShell>;
}